<template lang="">
    <div :class="$style.article">
        <div v-if="consultation.cover"  :class="$style.articleCover">
          <!-- <v-responsive :aspectRatio="240 / 150"> -->
          <v-responsive :aspectRatio="240 / 160">
            <nuxt-link :to="`/company/article/${consultation.no}`" :title="consultation.title" target="_blank">
              <el-image :class="$style.articleCover__img" fit="cover" :src="consultation.cover" lazy />
            </nuxt-link>
          </v-responsive>
        </div>
        <div :class="$style.articleContent">
          <h3 :class="$style.articleName"><nuxt-link :to="`/company/article/${consultation.no}`" target="_blank" :title="consultation.title">{{consultation.title}}</nuxt-link></h3>
          <p  :class="$style.articleDesc" >
            <nuxt-link class="break-all" :to="`/company/article/${consultation.no}`" v-html="consultation.summary" :title="consultation.title"  target="_blank" />
          </p>
          <p :class="$style.articleFooter">
            <nuxt-link :to="`/company/article/${consultation.no}`" :title="consultation.title" target="_blank">
              <span class="mr-2">来自主体：{{ fromText }}</span>
              <span class="mr-2" v-if="consultation.pageviews > 0">{{ consultation.pageviews }}次阅读</span>
              <span class="mr-8">{{consultation.create_time}}</span>
            </nuxt-link>
          </p>
        </div>
    </div>
</template>
<script>
import VResponsive from "@/components/VResponsive/VResponsive.vue";
export default {
  name: "ConsultationItem",
  components: {
    VResponsive,
  },
  props: {
    consultation: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    fromText() {
      return [this.consultation.author_name, this.consultation.source]
        .filter((item) => !!item)
        .join(" | ");
    },
  },
};
</script>
<style lang="scss" module>
.article {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  position: relative;
  z-index: 1;
}
.article::after {
  content: "";
  --tw-bg-opacity: 1;
  background-color: rgba(244, 246, 248, var(--tw-bg-opacity));
  --tw-bg-opacity: 0;
  margin: -10px;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: -1;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  -webkit-transition-duration: 300ms;
  -o-transition-duration: 300ms;
  transition-duration: 300ms;
}
.article:hover::after {
  --tw-bg-opacity: 1;
}
.article:hover .articleName {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.articleCover {
  -webkit-box-flex: 0;
  -ms-flex: none;
  -webkit-flex: none;
  flex: none;
  margin-right: 0.75rem;
  width: 15rem;
}
.articleCover__img {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  border-radius: 4px;
}
.articleContent {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
}
.articleName {
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.articleDesc {
  margin-top: 0.75rem;
  margin-bottom: 1rem;
  --tw-text-opacity: 1;
  color: rgba(164, 168, 180, var(--tw-text-opacity));
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.articleFooter {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  font-size: 0.8125rem;
  line-height: 1.125rem;
  margin-top: auto;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
</style>